/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Type of reward to payout.
 * @export
 */
export const RewardType = {
    FUEL: 'FUEL',
    NFT: 'NFT',
    PROMO: 'PROMO',
    PROMO_TOKEN: 'PROMO_TOKEN',
    MERCH: 'MERCH',
    GIFT_CARD: 'GIFT_CARD',
    XP: 'XP',
    XP_MULTIPLIER: 'XP_MULTIPLIER',
    LEADERBOARD_POINTS: 'LEADERBOARD_POINTS',
    FUELUP_MOVES: 'FUELUP_MOVES',
    HUB_POINTS: 'HUB_POINTS',
    RTTR_POINTS: 'RTTR_POINTS',
    LOOTSHOP_CREDIT: 'LOOTSHOP_CREDIT',
    LOOTBOX: 'LOOTBOX',
    BADGE: 'BADGE',
    OTHER: 'OTHER'
} as const;
export type RewardType = typeof RewardType[keyof typeof RewardType];


export function instanceOfRewardType(value: any): boolean {
    for (const key in RewardType) {
        if (Object.prototype.hasOwnProperty.call(RewardType, key)) {
            if (RewardType[key as keyof typeof RewardType] === value) {
                return true;
            }
        }
    }
    return false;
}

export function RewardTypeFromJSON(json: any): RewardType {
    return RewardTypeFromJSONTyped(json, false);
}

export function RewardTypeFromJSONTyped(json: any, ignoreDiscriminator: boolean): RewardType {
    return json as RewardType;
}

export function RewardTypeToJSON(value?: RewardType | null): any {
    return value as any;
}

export function RewardTypeToJSONTyped(value: any, ignoreDiscriminator: boolean): RewardType {
    return value as RewardType;
}

